/*
Spray Gun Parts
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Spray Gun Parts'
const id = 'OSBNnDMqB1ELU8nJK0Lc'

export default {
  name,
  id,
  filters,
  headers,
  form
}
